var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":'input_'+_vm.block.id},domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('markdown-editor',{ref:"input",attrs:{"value":this.block.text,"id":'input_'+_vm.block.id},on:{"input":_vm.handleInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbf378","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parts/Input/LongText.vue
// module id = null
// module chunks = 